// extracted by mini-css-extract-plugin
export default {"finalPage":"FinalPage_finalPage__27ouw","scrollLTR":"FinalPage_scrollLTR__C7PHy"};